import React, { FC, memo, useCallback, useMemo } from 'react';

import { isArray, sortBy } from 'lodash';

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    FlexColumn,
} from '@portal/common/components';
import theme, { styled } from '@portal/common/theme';

import _ from '../../locale/_';
import { accordionDetailsStyle } from './DataLicenseView';
import SummaryRow from './SummaryRow';

const Option = styled('span')<{ isDisabled }>(({ theme, isDisabled }) => ({
    color: isDisabled ? theme.color.gray40 : 'inherit',
    marginBottom: 10,
}));

const StyledFlexColumn = styled(FlexColumn)`
    margin-left: 105px;
    margin-top: 25px;
    margin-bottom: 15px;
`;

type Props = {
    data: {
        name: string;
        prefix?: string;
        totalItems: number[];
        items: number[];
        percentage: number;
    };
    id: string;
};

export const FilterRow: FC<Props> = memo(
    ({ data: { totalItems, items, name, prefix, percentage }, id }) => {
        const localizeFilterByPrefix = useCallback(
            (id: number) => (prefix ? _.get(prefix + id) : id),
            [prefix]
        );
        const records = useMemo(
            () =>
                sortBy(totalItems, localizeFilterByPrefix).map((id) => {
                    const isDisabled = !(isArray(items) && items.includes(id));
                    if (prefix === 'age_group_' && !_.get(prefix + id)) {
                        console.log(id);
                    }

                    return (
                        <Option key={id} isDisabled={isDisabled}>
                            - {localizeFilterByPrefix(id)}
                        </Option>
                    );
                }),
            [totalItems, localizeFilterByPrefix, items, prefix]
        );

        if (!(records && records.length)) {
            return null;
        }

        return (
            <div key={name}>
                <Accordion id={id} backgroundColor={theme.color.surface}>
                    <AccordionSummary arrowSize="medium">
                        <SummaryRow
                            name={name}
                            marginLeft={80}
                            percentage={percentage}
                            dataName={name}
                            items={items?.length}
                            totalItems={totalItems?.length}
                        />
                    </AccordionSummary>
                    <AccordionDetails style={accordionDetailsStyle}>
                        <StyledFlexColumn grow={1}>{records}</StyledFlexColumn>
                    </AccordionDetails>
                </Accordion>
            </div>
        );
    }
);

export default FilterRow;
